<template>
  <section>
    <div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
      <div class="main-containers">
        <div class="columns">
          <div class="column">
            <h3>Usuarios Relacionados</h3>
          </div>
          <div class="column">
          </div>
          <div>
            <vs-button
                color="primary"
                type="filled"
                class="btn btn-primary btn-group-sm"
                @click="cleanInformation">
              Limpiar información
            </vs-button>
          </div>
        </div>
        <hr/>
        <div>
          <div class="is-justify-content-center">
            <div>
              <div class="general-content-margin">
                <div class="columns">
                  <div class="column">
                    <div class="input-wrapper">
                      <label for="name">Nombre</label>
                      <input
                          v-model="name"
                          type="text"
                          :maxlength="30"
                          placeholder="Ingrese su nombre completo" class="input-default"
                          v-validate="'required'">
                    </div>
                  </div>
                  <div class="column">
                    <div class="input-wrapper">
                      <label for="lastname">Apellidos</label>
                      <input v-model="lastname"
                             type="text"
                             :maxlength="30"
                             placeholder="Ingrese su apellido completo"
                             class="input-default"
                             v-validate="'required'">
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="input-wrapper">
                      <label for="tower">Número de identificación</label>
                      <input v-model="identification"
                             type="text"
                             placeholder="Ingrese su ID o Cédula" class="input-default"
                             v-validate="'required'">
                    </div>
                  </div>
                  <div class="column">
                  </div>
                </div>
                <input
                    type="file"
                    ref="file"
                    accept="image/*"
                    class="hide"
                    @change="onChangeFile"/>
                <div class="columns">
                  <div class="column">
                    <div class="columns">
                      <div class="column">
                        <h5>Foto de usuario</h5>
                        <div class="column">
                          <input
                              type="file"
                              ref="file"
                              accept="image/*"
                              class="hide"
                              @change="onChangeFile"/>
                          <img :src="fileName" style="background-color: white"/>
                        </div>
                      </div>
                      <div class="column">
                        <div style="padding: 69px 0 0 0">
                          <div style="margin-bottom: 50px">
                            <vs-button
                                icon="add"
                                color="primary"
                                type="filled"
                                class="btn btn-primary"
                                @click="openExplorer">
                              Adjuntar foto
                            </vs-button>
                          </div>
                          <div>
                            <vs-button
                                icon="add"
                                color="danger"
                                type="filled"
                                class="btn btn-danger"
                                @click="photoDelete">
                              Eliminar foto
                            </vs-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">

                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <h5>1.Su foto tiene que ser en fondo blanco.</h5>
                    <h5>2.Tiene que tener buena luz de ambiente.</h5>
                  </div>
                  <div class="block">
                    <b-checkbox
                        class="checkbox"
                        type="checkbox"
                        v-model="isDisabled">
                      Acepta política tratamiento de datos
                    </b-checkbox>
                  </div>
                  <div >
                    <vs-button
                        icon="add"
                        color="primary"
                        type="filled"
                        class="btn btn-primary"
                        :disabled="!isDisabled"
                        @click="save()">
                      Registrarse
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import {configToast, TOAST_TYPES} from "@/global/toast";
import {GUARDIAN} from "@/global/api/api_guardian";
import {capitalizeFirstLetter, validateExtension} from "@/global/utils";
import {ROUTES} from "@/global/api_routes";

export default {
  name: "RegisterPerson",
  props: ['receivePlaceCode', 'companyCode'],
  data: () => ({
    name: null,
    lastname: null,
    identification: null,
    company: null,
    photo: [],
    identificationType:"1",
    isLoading: false,
    isDisabled : true,
    fileName: require('@/assets/images/guardian/user-avatar.png')
  }),
  watch: {
    receivePlaceCode() {
      this.cleanInformation();
    }
  },
  methods: {

    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#rates_container");
      return instance.open(message, type);
    },

    photoDelete(){
      this.$refs.file.value = null;
      this.fileName = require('@/assets/images/guardian/user-avatar.png');
    },

    cleanInformation() {
      this.name = null;
      this.lastname = null;
      this.identification = null;
      this.company = null;
      this.photo = [];
      this.$refs.file.value = null;
      this.fileName = require('@/assets/images/guardian/user-avatar.png');
    },

    getObjectEntity() {
      return {
        place: {
          code: this.receivePlaceCode,
        },
        entity: {
          name: capitalizeFirstLetter(this.name + " " + this.lastname),
          identification: this.identification,
          identificationType: this.identificationType,
        },
        photo: this.photo,
        company: {
          code: this.companyCode
        }
      };
    },

    transactionCompleted() {
      this.$emit("transactionCompleted", "person")
    },

    openExplorer() {
      this.$refs.file.click();
    },

    getFile() {
      const files = this.$refs.file.files;
      if (!files || files.length == 0) {
        return;
      }
      const file = files[0];
      return file;
    },

    onChangeFile() {
      const file = this.getFile();
      if(!validateExtension(file.name)){
        this.cleanInformation();
        this.toast("La foto debe contener un formato jpg, png", TOAST_TYPES.ERROR);
        return;
      }
      this.fileName = URL.createObjectURL(file);
    },

    uploadFile() {
      const formData = new FormData();
      const file = this.getFile();
      if (!file) {
        return;
      }
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        this.$http
            .post(ROUTES.GLOBAL.UPLOAD_FILE, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(({data}) => {
              if (data.code > 0) {
                resolve(data.info.code);
                return;
              }
              resolve(null);
            })
            .catch((error) => {
              resolve(null);
            });
      });
    },

    async save() {
      const validationResult = await this.$validator.validateAll();
      const files = this.$refs.file.files;
      if (!files || files.length == 0) {
        this.toast("La foto es requerida", TOAST_TYPES.ERROR);
        return;
      }
      if (!validationResult) {
        this.toast("Debe completar el formulario", TOAST_TYPES.ERROR);
        return;
      }
      const entity = this.getObjectEntity();
      this.isLoading = true;
      const fileCode = await this.uploadFile();
      if (fileCode === -1) {
        this.toast(
            "No se pudo subir el archivo correctamente",
            TOAST_TYPES.ERROR
        );
        return;
      }
      if (fileCode > 0) {
        entity.photo.push(fileCode);
      }

      this.$http.post(GUARDIAN.MANAGE_PERSON.REGISTER_PERSON, entity)
          .then(({data}) => {
            if (data.code > 0) {
              this.transactionCompleted();
              this.isLoading = false;
              this.cleanInformation();
              return;
            }
            this.toast("Verificar los datos ingresados, no se guardó la información");
            this.isLoading = false;
          });
    }
  }
}
</script>

<style scoped>
.general-content-margin {
  padding: 20px;
}

.main-containers {
  background-color: white;
  padding: 20px;
}

.input-wrapper {
  background-color: white;
  border: 1px solid rgba(34, 51, 84, 0.5);
  border-radius: 4px;
  position: relative;
  padding: 10px;
}

.input-wrapper input {
  border: none;
  position: relative;
  padding: 1px;
  width: 100%;
}

.input-wrapper label {
  position: absolute;
  top: -1.5ex;
  z-index: 1;
  left: 0.4em;
  background-color: white;
  padding: 0 5px;
  color: rgba(34, 51, 84, 0.5);
}

</style>



